function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("circle", {
  className: "spinner_svg__not-color",
  cx: 12,
  cy: 12,
  r: 9,
  stroke: "#B8B8B8",
  strokeWidth: 2
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12 3c3 0 9 2.143 9 9",
  stroke: "#4D4D4D",
  strokeWidth: 2.1,
  strokeLinecap: "round"
}, /*#__PURE__*/React.createElement("animateTransform", {
  attributeName: "transform",
  type: "rotate",
  from: "0 12 12",
  to: "360 12 12",
  dur: "1s",
  repeatCount: "indefinite"
}));

function SvgSpinner(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}

export default __webpack_public_path__ + "/img/spinner.svg";
export { SvgSpinner as ReactComponent };